"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _modal = _interopRequireDefault(require("@ux/modal"));
var _modalLoaderUtils = require("@wsb/modal-loader-utils");
var RenderMode = _modalLoaderUtils.CONSTANTS.RenderMode;
var isModalRender = _modalLoaderUtils.HELPERS.isModalRender;
var DEFAULT_TITLE = 'Something went wrong';
var DEFAULT_MESSAGE = 'Oops! Something went wrong. Please refresh your browser and try again or contact support';
var DefaultError = function DefaultError(_ref) {
  var className = _ref.className,
    dataAid = _ref['data-aid'],
    message = _ref.message,
    renderMode = _ref.renderMode,
    style = _ref.style,
    title = _ref.title,
    onClose = _ref.onClose;
  if (isModalRender(renderMode)) {
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: title,
      onClose: onClose,
      id: "ml-default-error"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: className,
      "data-aid": dataAid,
      style: style
    }, /*#__PURE__*/_react.default.createElement("p", null, message)));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className,
    "data-aid": dataAid,
    style: style
  }, /*#__PURE__*/_react.default.createElement("h3", null, title), /*#__PURE__*/_react.default.createElement("p", null, message));
};
DefaultError.propTypes = {
  'className': _propTypes.default.string,
  'data-aid': _propTypes.default.string,
  'message': _propTypes.default.string,
  'renderMode': _propTypes.default.oneOf([RenderMode.MODAL, RenderMode.EMBED]),
  'style': _propTypes.default.object,
  'title': _propTypes.default.string,
  'onClose': _propTypes.default.func
};
DefaultError.defaultProps = {
  'data-aid': 'ml-error',
  'message': DEFAULT_MESSAGE,
  'renderMode': RenderMode.MODAL,
  'title': DEFAULT_TITLE
};
var _default = exports.default = DefaultError;